import { useCallback, useEffect, useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { EUISnackBarMessageType, showBasicSnackBar } from '@aquariuxfintech/aqx-trader-react-ui/snack-bar';

import { experienceViewController } from '@aqx-core/common/services/experience';

export const useExperienceAccountRedirect = () => {
  const { search } = useLocation();

  const { redirectId, extendTrial } = useMemo(() => {
    const searchParams = new URLSearchParams(search);
    return {
      redirectId: searchParams.get('redirectId') || undefined,
      extendTrial: searchParams.get('extendTrial') === 'true'
    };
  }, [search]);

  const onSuccess = useCallback((message: string) => {
    showBasicSnackBar({
      messageType: EUISnackBarMessageType.SUCCESS,
      message
    });
  }, []);

  const onError = useCallback((message: string) => {
    showBasicSnackBar({
      messageType: EUISnackBarMessageType.ERROR,
      message
    });
  }, []);

  useEffect(() => {
    if (redirectId) {
      experienceViewController.queryExperienceIdentifier(redirectId, extendTrial, { onSuccess, onError });
    }
    return () => {
      experienceViewController.reset();
    };
  }, [redirectId, extendTrial, onSuccess, onError]);
};
